export const useLanguageMenu = () => { // ใช้สำหรับรวมภาษาในระบบตอนเลือก dropdown ภาษา
  const LANGUAGE_MENU = [
    { value: "en", label: "EN" },
    { value: "th", label: "TH" },
  ];

  return { LANGUAGE_MENU };
};
